import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideDesignAngularKit } from 'design-angular-kit';
import { provideTranslateService } from '@ngx-translate/core';

import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { keycloakAuthInterceptor } from './interceptors/keycloak-auth-interceptor';
import { DatePipe } from '@angular/common';
import { csrfInterceptor } from './interceptors/csrf-interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'top', 
        anchorScrolling: 'enabled'        
      })
    ),
    // Mantenere l'interceptor CSRF per primo: aggiorna il token e ritenta prima della gestione globale degli errori.
    provideHttpClient(withInterceptors([csrfInterceptor, keycloakAuthInterceptor])),
    DatePipe,


    provideTranslateService({
      defaultLanguage: 'it',
      loader: provideTranslateHttpLoader({ prefix: '/bootstrap-italia/i18n/', suffix: '.json' }),
    }),

    provideDesignAngularKit({
      assetBasePath: '/bootstrap-italia',
    }),
  ],
};
